import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';
import { INTUIT_EDUCATION_URL } from './constants';

const App = () => {
    const isEmbeddedIFrame = window.self !== window.top;

    return (
        <div className="sid-verification-form">
            {!isEmbeddedIFrame && (
                <div className="sid-headband sid-l-container">
                    <a href={INTUIT_EDUCATION_URL}>
                        <img className="sid-headband__logo" src="./img/logo.png" alt="Intuit Education" />
                    </a>
                    <hr className="sid-headband__rule"></hr>
                </div>
            )}
            <VerificationForm programId={programId} />
        </div>
    );
};

export default App;
